import { InjectionToken } from '@angular/core';
import type { ApiExplorerTheme } from './api-explorer.models';

/** Per-app color theme for the API Explorer modal. */
export const API_EXPLORER_THEME = new InjectionToken<ApiExplorerTheme>('API_EXPLORER_THEME');

/** Optional default resource-server URL prepended to the OpenAPI spec servers list. */
export const API_EXPLORER_SERVER_URL = new InjectionToken<string>('API_EXPLORER_SERVER_URL');
